import { render, staticRenderFns } from "./spamPolicy.vue?vue&type=template&id=80588920"
import script from "./spamPolicy.vue?vue&type=script&lang=js"
export * from "./spamPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports